if (!window.Eurus.loadedScript.has('header.js')) {
  window.Eurus.loadedScript.add('header.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xHeaderMenu', {
        isSticky: false,
        stickyCalulating: false,
        openHamburgerMenu: false,
        isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
        sectionId: '',
        stickyType: 'none',
        lastScrollTop: 0,
        themeModeChanged: false,
        scrollY: 0,
        stickyOffsetHeight: 0,
        announcementOffsetHeight: 0,
        mobileHeaderLayout: '',
        show: null,
        subShow: new Map(),
        overlay: false,
        initIndex: new Set(),
        scrollDir: '',
        isMenuOpen: false,
        initialized: false,
        passTop: false,
        passBottom: false,
        debounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        },
        
        // Muse 2026-10-26: theme position:sticky paint-clips nav after scroll-back (Chrome).
        // When sticky_header_type is none, use fixed-on-scroll instead.
        // Re-query DOM each tick so product pages that re-render the header still pin.
        initMuseFixedHeader() {
          if (this._museFixedInit) return;
          this._museFixedInit = true;
          let spacer = null;
          let fixed = false;
          let lastH = 0;
          const apply = () => {
            const section = document.querySelector('.section-header');
            const content = document.getElementById('sticky-header-content');
            if (!section || !content) return;
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            const start = section.offsetTop || 0;
            if (y > start + 2) {
              if (!fixed || !content.classList.contains('muse-fixed-header')) {
                const h = Math.max(section.getBoundingClientRect().height, content.getBoundingClientRect().height, lastH, 1);
                lastH = h;
                if (!spacer || !spacer.isConnected) {
                  spacer = document.createElement('div');
                  spacer.setAttribute('data-muse-sticky-spacer', '1');
                  spacer.style.width = '100%';
                  section.after(spacer);
                }
                spacer.style.height = h + 'px';
                content.style.setProperty('position', 'fixed', 'important');
                content.style.setProperty('top', '0', 'important');
                content.style.setProperty('left', '0', 'important');
                content.style.setProperty('right', '0', 'important');
                content.style.setProperty('width', '100%', 'important');
                content.style.setProperty('z-index', '50', 'important');
                content.classList.add('muse-fixed-header');
                fixed = true;
              }
            } else if (fixed || content.classList.contains('muse-fixed-header')) {
              content.style.removeProperty('position');
              content.style.removeProperty('top');
              content.style.removeProperty('left');
              content.style.removeProperty('right');
              content.style.removeProperty('width');
              content.style.removeProperty('z-index');
              content.classList.remove('muse-fixed-header');
              if (spacer) { spacer.remove(); spacer = null; }
              fixed = false;
            }
          };
          window.addEventListener('scroll', () => requestAnimationFrame(apply), { passive: true });
          window.addEventListener('resize', () => {
            if (fixed && spacer) {
              const content = document.getElementById('sticky-header-content');
              const h = content ? content.getBoundingClientRect().height : lastH;
              spacer.style.height = h + 'px';
            }
          }, { passive: true });
          document.addEventListener('shopify:section:load', () => {
            fixed = false;
            if (spacer) { spacer.remove(); spacer = null; }
            requestAnimationFrame(apply);
          });
          // Product pages / apps can delay layout — retry a few times
          apply();
          setTimeout(apply, 500);
          setTimeout(apply, 1500);
          setTimeout(apply, 3000);
        },

        initSticky(headerContainer, stickyType, transparent) {
          setTimeout(() => {
            if (stickyType === 'none') {
              this.initMuseFixedHeader();
              return;
            }

            const header = document.getElementById(`shopify-section-${this.sectionId}`);

            const sentinelTop = document.createElement('div');
            sentinelTop.id = "x-header-sentinel-top"
            const sentinelBottom = document.createElement('div');
            sentinelBottom.id = "x-header-sentinel-bottom"
            header.before(sentinelTop);
            header.after(sentinelBottom);

            const headerObserver = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.target === header) {
                  if (!this.initialized) {
                    const rect = entry.boundingClientRect;
                    if (transparent) {
                      this.stickyOffsetHeight = document.getElementById('sticky-header-content').offsetHeight;
                    } else {
                      this.stickyOffsetHeight = rect.height;
                    }
                    
                    const announcement = document.getElementById("x-announcement");

                    if (announcement?.dataset.isSticky === 'true') {
                      this.announcementOffsetHeight = announcement?.offsetHeight;
                    }

                    this.initVariable(header, headerContainer, stickyType);
                    this.initScrollEvent(header, headerContainer, stickyType);
                    this.initHeaderHeightEvent();

                    this.initialized = true;
                  }
                } else if (entry.target === sentinelTop) {
                  this.passTop = !entry.isIntersecting;
                } else {
                  this.passBottom = !entry.isIntersecting;
                }
              })
            })

            headerObserver.observe(header);
            headerObserver.observe(sentinelTop);
            headerObserver.observe(sentinelBottom);
          }, 0)
        },
        initVariable(header, headerContainer, stickyType) {
          requestAnimationFrame(() => {
            header.style.setProperty('--announcement-height', this.announcementOffsetHeight + "px");
            header.style.setProperty('--header-sticky-transform', (0 - this.announcementOffsetHeight - this.stickyOffsetHeight) + "px");
          });
          this.handleStickyScrolling(header, headerContainer, stickyType);
        },
        initScrollEvent(header, headerContainer, stickyType) {
          let scrollDebounce = null;
          const onScroll = () => {
            clearTimeout(scrollDebounce);
            scrollDebounce = setTimeout(() => {
              let scrollPos = window.scrollY || document.documentElement.scrollTop;
              this.handleStickyScrolling(header, headerContainer, stickyType, scrollPos);
            }, 50);
          };
          window.addEventListener('scroll', onScroll, {passive: true});
        },
        handleStickyScrolling(header, headerContainer, stickyType, scrollPos) {
          const dir = this.scrollY < scrollPos;
          this.scrollY = scrollPos;
          requestAnimationFrame(() => {
            if (stickyType === 'always') {
              this.setVariableHeightHeader(true);
              if (this.passBottom) {
                headerContainer.classList.add('is-scrolled');
              } else {
                headerContainer.classList.remove('is-scrolled');
              }
              // Muse fix 2026-10-26: Chrome clips nav paint after sticky unstick; force layer refresh at top
              if (!this.passTop) {
                header.style.transform = 'translateZ(0)';
                void header.offsetHeight;
                header.style.transform = '';
              }
            } else if (stickyType === 'reduce-logo-size') {
              this.setVariableHeightHeader(true);
              if (this.passBottom) {
                headerContainer.classList.add('reduce-logo-size', 'is-scrolled');
              } else {
                headerContainer.classList.remove('reduce-logo-size', 'is-scrolled');
              }
            } else {
              let stickyTimeout = null;

              if (!this.passTop) {
                header.classList.remove('is-sticky', 'is-scrolled');
                headerContainer.classList.remove('on-scroll-up-animation');
                this.isSticky = false;
              }
              if (this.passBottom && dir) {
                if (!stickyTimeout) {
                  stickyTimeout = setTimeout(() => {
                    header.classList.add('is-sticky', 'is-scrolled');
                    this.isSticky = true;
                  }, 550);
                }
                headerContainer.classList.add('on-scroll-up-animation');
                this.setVariableHeightHeader(false);
              } else {
                headerContainer.classList.remove('on-scroll-up-animation');
                this.setVariableHeightHeader(true);
              }
            }
          });
        },
        initHeaderHeightEvent() {
          const els = document.querySelectorAll('[class*="--height-header"]');
          document.addEventListener('eurus:sticky-header-moved', (e) => {
            els.forEach(el => {
              el.style.setProperty('--height-header', e.detail.heightHeader + "px");
            });
          })
        },
        setVariableHeightHeader(isSticky) {
          const heightHeader = isSticky ? this.announcementOffsetHeight + this.stickyOffsetHeight : this.announcementOffsetHeight;
          document.dispatchEvent(new CustomEvent("eurus:sticky-header-moved", { detail: { heightHeader: heightHeader } }))
        },
        renderAjax(el, id, element) {
          fetch(
            `${window.location.pathname}?sections=${id}`
          ).then(response => response.json())
          .then(response => {
            let html = getSectionInnerHTML(response[id], element);
            if (el?.closest('[data-breakpoint="tablet"]')) {
              html = html?.replace('id="search-in-modal"', 'id="search-in-modal-mobile"');
            }
            el.innerHTML = html;
          })
        },
        setPosition(el, level, hamburger=false) {
          if (!hamburger) {
            level = level - 1;
          } else {
            level = level - 0.5;
          }
          requestAnimationFrame(() => {
            const elm = el.closest(".tree-menu");

            const widthEl = elm.getElementsByClassName("toggle-menu")[0];
            const widthElWitdth = widthEl.offsetWidth;
            const viewWidth = window.xViewport.innerWidth || document.documentElement.clientWidth

            const elRect = elm.getBoundingClientRect();

            const left = (elRect.left - (widthElWitdth * level)) < 100;
            const right = (elRect.right + (widthElWitdth * level)) > (viewWidth - 100);

            const isRtl = document.querySelector('body').classList.contains('rtl');

            requestAnimationFrame(() => {
              if (isRtl) {
                if (left) {
                  el.classList.add('right-0');
                  widthEl.classList.add('left-0');
                  elm.classList.remove('position-left');
                } else {
                  el.classList.add('left-0');
                  widthEl.classList.add('right-0');
                  elm.classList.add('position-left');
                }
              } else { 
                if (right) {
                  el.classList.add('left-0');
                  widthEl.classList.add('right-0');
                  elm.classList.add('position-left');
                } else {
                  el.classList.add('right-0');
                  widthEl.classList.add('left-0');
                  elm.classList.remove('position-left');
                }
              }  
            })
          })
        },
        resizeWindow(el,level, hamburger=false) {
          const onResize = this.debounce(() => {
            this.setPosition(el, level, hamburger);
          }, 100);

          addEventListener("resize", onResize);
        },
        toggleMenu(index) {
          this.initIndex.add(index);
          this.show = this.show === index ? 0 : index;
          this.overlay = (this.show !== 0);
        },
        openMenu(index) {
          this.initIndex.add(index);
          this.show = index;
          this.overlay = true;
        },
        closeMenu() {
          this.show = 0;
          this.overlay = false;
        },
        openSubMenu(key, index) {
          this.subShow.set(key, index);
        },
        updateHeight(el, containerId) {
          const container = document.getElementById(containerId);
          let currentAnimation = null;
          let previousHeight = null;
          
          const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
              const newHeight = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
              
              if (previousHeight !== null && Math.abs(previousHeight - newHeight) >= 1) {
                currentAnimation?.cancel();
                
                currentAnimation = container.animate([
                  { height: `${previousHeight}px` },
                  { height: `${newHeight}px` }
                ], { duration: 300, easing: 'ease-in-out' });
              }
              
              container.style.height = newHeight + 'px';
              previousHeight = newHeight;
            }
          });

          observer.observe(el);
        },
        touchItem(el, isSub = false) {
          const touchClass = isSub ? 'touched-sub' : 'touched';

          el.addEventListener("touchend", (e) => {
            if (el.classList.contains(touchClass)) {
              window.location.replace(el.getAttribute('href'));
            } else {
              e.preventDefault(); 
              var dropdown = document.querySelectorAll(`.${touchClass}`);
              for (var i = 0; i < dropdown.length; i++) { 
                dropdown[i].classList.remove(touchClass); 
              }

              el.classList.add(touchClass);
              this.selectItem(el.closest('.has-dropdown'), isSub);
            }
          });
        },
      });
    });
  });
}